import { ColorOptions, email } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { isEmpty } from '@jfs/utils'
import { Dropdown } from '../../components/Dropdown'

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

const types = [
  {
    id: 1,
    value: 'TOPS',
  },
  {
    id: 2,
    value: 'DEV',
  },
  {
    id: 3,
    value: 'PRODUCT',
  },
  {
    id: 4,
    value: 'Integration',
  },
  {
    id: 5,
    value: 'FinOps',
  },
  {
    id: 6,
    value: 'Operations',
  },
  {
    id: 7,
    value: 'S&R',
  },
  {
    id: 8,
    value: 'Risk',
  },
  {
    id: 9,
    value: 'Business',
  },
  {
    id: 10,
    value: 'Compliance',
  },
  {
    id: 11,
    value: 'Support',
  },
]

const statusData = [
  {
    id: 1,
    value: 'Active',
  },
  {
    id: 2,
    value: 'InActive',
  },
]

export const UserForm: any = (groupIdNames: any, id: any) => {
  return [
    {
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'username',
              displayName: 'UserName',
              ComponentName: TextInputNew,
              label: 'UserName',
              validationSchema: isEmpty(id) ? email : undefined,
              placeholder: 'Usename',
              editable: isEmpty(id),
              ...textinputStyle,
            },
            {
              fieldName: 'type',
              ComponentName: Dropdown,
              minWidth: 640,
              title: 'Type',
              label: 'Type',
              data: types,
            },
            {
              fieldName: 'name',
              ComponentName: Dropdown,
              minWidth: 140,
              title: 'Group',
              label: 'Group',
              data: groupIdNames,
            },
            {
              hide: id === undefined, //Need not to show in add user.
              fieldName: 'status',
              ComponentName: Dropdown,
              minWidth: 140,
              title: 'Status',
              label: 'Status',
              data: statusData,
            },
          ],
        },
      ],
      horizontalFlex: 1,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
}
